import styled, { css } from 'styled-components';
import { Icon } from 'antd';
import { Link } from 'react-router-dom';

import { mapCSS } from '../helpers';

export const primary = (styles, theme) => css`
	${styles};
	border: none;
	background: linear-gradient(0deg, #31549b 0%, #2786bf 53.8%),
		linear-gradient(180deg, #4d8fc1 0%, #2b4b87 100%);
	border-radius: 4px;
	color: ${theme.white};
	font-weight: ${theme.font.bold};
	&:hover:not([disabled]) {
		filter: brightness(105%);
		transition: all 0s ease-in-out;
		box-shadow: ${`0px 0px 0.25rem ${theme.blueAzure}`};
	}
	&:disabled {
		filter: brightness(50%);
		cursor: auto;
	}
`;

export const reject = (styles, theme) => css`
	${styles};
	background: radial-gradient(
			57.43% 157.84% at 30.18% 5.11%,
			rgba(255, 255, 255, 0.2) 0%,
			rgba(155, 155, 155, 0.2) 36.68%,
			rgba(113, 112, 112, 0.2) 64.6%,
			rgba(78, 78, 78, 0.2) 100%
		),
		linear-gradient(0deg, rgba(0, 0, 0, 0.3), rgba(0, 0, 0, 0.3)) !important;

	border: 1px solid #e0e0e04d !important;
	border-radius: 4px;
	color: ${theme.white};
	font-weight: ${theme.font.bold};
	border-image-source: linear-gradient(
		180deg,
		rgba(224, 224, 224, 0.37) 0%,
		rgba(255, 255, 255, 0.5) 20.52%,
		rgba(106, 106, 106, 0.5) 65%
	);
	&:hover:not([disabled]) {
		filter: brightness(150%);
		-webkit-transition: all 0.5s ease-in-out;
		-moz-transition: all 0.5s ease-in-out;
		-o-transition: all 0.5s ease-in-out;
		-ms-transition: all 0.5s ease-in-out;
		transition: all 0.5s ease-in-out;
	}
	&:disabled {
		filter: brightness(50%);
		cursor: auto;
	}
`;

export const Loader = styled(Icon)`
	font-size: ${({ size }) => size};
	color: ${({ theme }) => theme.white};
	margin-right: 1rem;
`;

export const StyledButton = styled.button`
	${({ theme, themes, styles }) =>
		themes === 'primary'
			? primary(mapCSS(styles), theme)
			: reject(mapCSS(styles), theme)};
`;

export const StyledLink = styled(Link)`
	${({ themes, theme, styles }) =>
		themes === 'primary'
			? primary(mapCSS(styles), theme)
			: reject(mapCSS(styles), theme)};
`;

export const StyledAnchor = styled.a`
	${({ themes, theme, styles }) =>
		themes === 'primary'
			? primary(mapCSS(styles), theme)
			: reject(mapCSS(styles), theme)};
`;
